import { useEffect } from "react"
import { useParams, Navigate, Outlet } from "react-router-dom"
import { useTranslation } from "react-i18next"

const SUPPORTED_LANGUAGES = ["en", "fi", "se"] as const
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

const LanguageWrapper = () => {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  // Sync i18n language with URL parameter
  useEffect(() => {
    if (lang) {
      // Always change language when lang param changes
      // i18next will handle no-op if language is already set
      i18n.changeLanguage(lang)
      // Save language preference to localStorage
      localStorage.setItem("preferredLanguage", lang)
    }
  }, [lang, i18n])

  // Validate language parameter
  if (!lang || !SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage)) {
    // Invalid language - redirect to English customer page
    const canonicalPath = i18n.getResource("en", "translation", "routes.customer.canonical")
    return <Navigate to={`/en/${canonicalPath}`} replace />
  }

  // Render child routes
  return <Outlet />
}

export default LanguageWrapper
